"use strict";
exports.__esModule = true;
exports.UserOrganisation = void 0;
var UserOrganisation = /** @class */ (function () {
    function UserOrganisation(id, app_domain, invite_accepted) {
        this.id = id;
        this.app_domain = app_domain;
        this.invite_accepted = invite_accepted;
    }
    UserOrganisation.fromJSON = function (json) {
        var userOrganisation = new UserOrganisation('', '', false);
        if (json && json.id) {
            userOrganisation.id = json.id ? json.id : '';
            userOrganisation.app_domain = json.app_domain ? json.app_domain : '';
            userOrganisation.invite_accepted = json.invite_accepted !== undefined ? json.invite_accepted : false;
        }
        return userOrganisation;
    };
    return UserOrganisation;
}());
exports.UserOrganisation = UserOrganisation;
